import React__default from 'react';
import classNames from './../external_lib/classnames/index.js';
import LazyImage from '../Atoms/LazyImage.js';
import { useTranslation } from 'react-i18next';
import Typography from '../Atoms/Typography.js';
import Button from '../Atoms/Button.js';

function FeaturedDishTwo(_a) {
    var classes = _a.classes, description = _a.description, onOrderNowClick = _a.onOrderNowClick, image = _a.image, imageComponent = _a.imageComponent, title = _a.title;
    var t = useTranslation().t;
    var handleOrderNowClick = function () {
        onOrderNowClick && onOrderNowClick();
    };
    return (React__default.createElement("div", { className: classNames('featured-dishes-two', classes) },
        React__default.createElement("div", { className: "featured-dishes-two__item-section" },
            React__default.createElement(Typography, { variant: "displayText", classes: "featured-dishes-two__title" }, title ? title : t('landingScreen.featuredDish')),
            React__default.createElement(Typography, { classes: "featured-dishes-two__item-description", variant: "bodyTextOne" }, description),
            React__default.createElement(Button, { size: "lg", variant: "solid", classes: "featured-dishes-two__cta", onClick: handleOrderNowClick }, t('landingScreen.orderNow'))),
        React__default.createElement(LazyImage, { classes: "featured-dishes-two__item-image", src: image, alt: "featured dish", imageComponent: imageComponent }),
        React__default.createElement(Button, { variant: "link", size: "lg", classes: "featured-dihes-two__mobile__cta", onClick: handleOrderNowClick }, t('landingScreen.readMore'))));
}

export { FeaturedDishTwo as default };
//# sourceMappingURL=FeaturedDishTwo.js.map
